import { jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
export class Portal extends React.Component {
    constructor(props) {
        super(props);
        Object.defineProperty(this, "el", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.el = document.createElement('div');
    }
    componentDidMount() {
        const { targetElement } = this.props;
        if (!targetElement)
            throw new Error('Portals targetElement was undefined.');
        targetElement.prepend(this.el);
    }
    componentWillUnmount() {
        const { targetElement } = this.props;
        if (!targetElement)
            throw new Error('Portals targetElement was undefined.');
        targetElement.removeChild(this.el);
    }
    render() {
        const { children } = this.props;
        if (!this.el)
            return _jsx(Fragment, {});
        return ReactDOM.createPortal(children, this.el);
    }
}
//# sourceMappingURL=Portal.js.map